import { cv, profile } from "../data/content";

function Timeline({ items }) {
  return (
    <ul className="timeline">
      {items.map((item) => (
        <li key={`${item.title}-${item.period}`} className="timeline-item">
          <span className="timeline-period">{item.period}</span>
          <div className="timeline-body">
            <h3>{item.title}</h3>
            <p className="timeline-place">{item.place}</p>
            <p className="timeline-detail">{item.detail}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function CV() {
  return (
    <div className="page cv-page">
      <header className="page-header">
        <h1>Curriculum Vitae</h1>
        <p>
          A snapshot of education, research, and selected awards. Replace with
          your full CV when ready.
        </p>
        <a className="btn btn-ghost" href={`mailto:${profile.email}`}>
          Request PDF
        </a>
      </header>

      <section className="cv-block">
        <h2 className="section-title">Education</h2>
        <Timeline items={cv.education} />
      </section>

      <section className="cv-block">
        <h2 className="section-title">Experience</h2>
        <Timeline items={cv.experience} />
      </section>

      <section className="cv-block">
        <h2 className="section-title">Awards</h2>
        <ul className="award-list">
          {cv.awards.map((a) => (
            <li key={a.title}>
              <span className="award-year">{a.year}</span>
              <span>{a.title}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="cv-block">
        <h2 className="section-title">Skills</h2>
        <ul className="skill-list">
          {cv.skills.map((s) => (
            <li key={s}>{s}</li>
          ))}
        </ul>
      </section>
    </div>
  );
}
